import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const [activeTab, setActiveTab] = useState('all');

  const allCategories = [
    { slug: 'all', name: '全部', icon: 'ri-apps-line', count: categories.reduce((sum, c) => sum + c.count, 0) },
    ...categories,
  ];

  return (
    <section className="py-8 md:py-10 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2.5 mb-5">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
            <i className="ri-grid-line text-foreground-950 text-base"></i>
          </div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            分类吃瓜
          </h2>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {allCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveTab(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-700 hover:text-foreground-950 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
          {(activeTab === 'all' ? categories : categories.filter((c) => c.slug === activeTab)).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300 no-underline"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors mb-1">
                  {cat.name}
                </h4>
                <p className="text-xs text-foreground-500 line-clamp-1">{cat.description}</p>
                <span className="inline-block mt-1.5 text-xs text-foreground-400">{cat.count} 条爆料</span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center text-foreground-400 group-hover:text-accent-500 transition-colors flex-shrink-0 self-center">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}